import { useState, useEffect } from "react";

const useEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchEvents = async () => {
    try {
      const response = await fetch("https://awaretherapycenter.ro/events-back/list/");
      const data = await response.json();
      setEvents(data);
    } catch (error) {
      console.error("Eroare la preluarea evenimentelor:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  return { events, loading, fetchEvents };
};

export default useEvents;
